import { AdminRole } from '@/constants/roles/roles';

export interface INavigationRoute {
  name: string;
  displayName: string;
  meta: { icon: string };
  children?: INavigationRoute[];
  allowedRoles?: AdminRole[];
}

const routes = (): INavigationRoute[] => [
  {
    name: 'users',
    displayName: 'menu.users',
    meta: {
      icon: 'group',
    },
  },
  {
    name: 'agreements',
    displayName: 'Соглашения',
    meta: {
      icon: 'group',
    },
  },
  {
    name: 'subscriptions',
    displayName: 'Управление подписками',
    meta: {
      icon: 'group',
    },
  },
  {
    name: 'settings',
    displayName: 'menu.settings',
    meta: {
      icon: 'settings',
    },
  },
];

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: routes(),
};
